import React, { createContext, useContext, useMemo, useRef } from 'react';

import { TripSearchOpenHandle } from '../components/search/tripSearchOpenHandle';

interface PhoneTripSearch {
  /** Where the phone app bar's trip search pill registers its open handle. */
  openRef: React.RefObject<TripSearchOpenHandle>;
  /** Opens the pill's search sheet from elsewhere on the page; does nothing without a pill. */
  openTripSearch: () => void;
}

const NO_PHONE_TRIP_SEARCH: PhoneTripSearch = {
  openRef: { current: null },
  openTripSearch: () => undefined,
};

const PhoneTripSearchContext = createContext<PhoneTripSearch>(NO_PHONE_TRIP_SEARCH);

export const PhoneTripSearchProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const openRef = useRef<TripSearchOpenHandle>(null);
  const value = useMemo<PhoneTripSearch>(
    () => ({ openRef, openTripSearch: () => openRef.current?.open() }),
    [],
  );
  return (
    <PhoneTripSearchContext.Provider value={value}>{children}</PhoneTripSearchContext.Provider>
  );
};

export function usePhoneTripSearch(): PhoneTripSearch {
  return useContext(PhoneTripSearchContext);
}
